import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/me/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  const stats = [
    { k: "Orders", v: orders.length },
    { k: "Spent", v: money(orders.reduce((n, o) => n + o.total_cents, 0)) },
    { k: "Documents", v: new Set(orders.flatMap((o) => o.items.map((i) => i.product_id))).size },
  ];

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-3 gap-4">
        {stats.map((s) => (
          <div key={s.k} className="border border-black/10 p-6">
            <div className="overline">{s.k}</div>
            <div className="font-display text-3xl font-bold mt-2">{s.v}</div>
          </div>
        ))}
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <div className="overline">Recent orders</div>
          <Link to="/account/orders" className="text-sm link-underline">View all</Link>
        </div>
        {orders.length === 0 ? (
          <div className="border border-dashed border-black/20 p-10 text-center text-zinc-600">
            No orders yet. <Link to="/shop" className="link-underline">Browse the catalog.</Link>
          </div>
        ) : (
          <div className="border border-black/10 divide-y divide-black/10">
            {orders.slice(0, 5).map((o) => (
              <Link key={o.id} to={`/account/orders/${o.id}`} className="p-4 flex items-center justify-between hover:bg-zinc-50" data-testid={`order-row-${o.order_number}`}>
                <div>
                  <div className="font-mono text-sm">{o.order_number}</div>
                  <div className="text-xs text-zinc-500 mt-1">{new Date(o.created_at).toLocaleString()}</div>
                </div>
                <div className="text-right">
                  <div className="font-mono">{money(o.total_cents)}</div>
                  <div className="overline mt-1">{o.status}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      <div>
        <div className="overline mb-3">Account</div>
        <div className="border border-black/10 p-6">
          <div className="text-sm">Signed in as <span className="font-mono">{user?.email}</span></div>
          <div className="text-xs text-zinc-500 mt-1">Role: {user?.role}</div>
        </div>
      </div>
    </div>
  );
}
